// extracted by mini-css-extract-plugin
export default {"container":"Treatment_container__hBH8k","changePlan":"Treatment_changePlan__M5UtN","treatmentContainer":"Treatment_treatmentContainer__sNNGw","heading":"Treatment_heading__Lh4aN"};